// @flow
import React, {Component} from 'react';
import { connect } from 'react-redux';
import {
  clearPdfsForm, editPdfs,
  storeIsPublic, storeIsPublicForAllPdfs, storeTemporaryPdf,
  uploadPdfs
} from '../actions/pdfs';
import { parseArePdfsPublic, parseListOfPdfs, parsePdfsEdit } from '../helpers/parseImmutables';
import PdfsForm from '../components/Pdfs/pdfsForm';
import { PDF_TYPES } from '../helpers/constants/productAttachmentTypes';

class PdfsAddHOC extends Component {
  state = {
    title: '',
    description: '',
    warning: undefined,
    productId: undefined,
    pdfsToUpload: [],
  };

  componentDidMount() {
    this.props.clearPdfsForm();

    // this means we are editing
    if (this.props.pdfs.length) {
      const pdfsToUpload = [];
      const isPublic = {
        [PDF_TYPES.PDF_FRONTPAGE_ONE]: false,
        [PDF_TYPES.PDF_FRONTPAGE_TWO]: false,
        [PDF_TYPES.PDF_FRONTPAGE_THREE]: false,
        [PDF_TYPES.PDF_FRONTPAGE_FOUR]: false,
        [PDF_TYPES.PDF_FRONTPAGE_FIVE]: false,
      };
      this.props.pdfs.forEach(pdf => {
        pdfsToUpload.push({
          id: pdf.id,
          pdfType: pdf.pdfType,
          attachment: {
            name: pdf.filename
          },
          isPublic: pdf.isPublic
        })
        isPublic[pdf.pdfType] = pdf.isPublic;
      })
      this.setState({
        pdfsToUpload,
      })
      this.props.storeIsPublicForAllPdfs(isPublic);
    }
  }

  setField = (name, value) => {
    this.setState({
      [name]: value,
    })
  };

  setSelectedProduct = (productId) => {
    this.setState({
      productId: productId,
    })
  };

  handleSubmit = (evt) => {
    evt.preventDefault();

    if (!this.props.pdfs.length) {
      this.props.uploadPdfs({
        pdfs: this.state.pdfsToUpload,
        isPublic: this.props.isPublic,
      })
    } else {
      this.props.editPdfs({
        pdfs: this.state.pdfsToUpload,
        isPublic: this.props.isPublic,
      })
    }
  };

  clearWarning = () => {
    this.setState({warning: undefined});
  };

  handlePdfInput = (evt, typeOfPdf) => {
    let e = evt.target.files;
    let reader = new FileReader();
    let handleChange ;
    const scope = this;
    try {
      reader.readAsText(e[0]);
      reader.onload = function () {
        let attachment = {
          name: e[0].name,
          type: e[0].type,
          pdfType: typeOfPdf,
          file: e[0]
        };
        reader.readAsDataURL(e[0]);
        reader.onload = () => {
          attachment = {...attachment, base64: reader.result};
          let pdfsToUpload = scope.state.pdfsToUpload;
          const alreadyExistingItem =
            scope.state.pdfsToUpload
              .filter(pdf => pdf.pdfType === typeOfPdf)
          if (alreadyExistingItem.length) {
            pdfsToUpload = pdfsToUpload.filter(pdf => pdf.pdfType !== alreadyExistingItem[0].pdfType)
          }
          pdfsToUpload.push({
            pdfType: typeOfPdf,
            attachment,
          });
          scope.setState({
            pdfsToUpload,
          })
        };
        reader.onerror = (error) => {
          console.log('Error: ', error);
        }
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    }
    catch (e) {

    }
  };

  removePdf = (typeOfPdf) => {
    const scope = this;
    const pdfsRemaining = scope.state.pdfsToUpload
      .filter(pdf => pdf.pdfType !== typeOfPdf);
    scope.setState({
      pdfsToUpload: pdfsRemaining
    })
  }

  render() {
    const {
      navigation, storeTemporaryPdfImage, tempImage,
    } = this.props;

    return (
      <PdfsForm
        title={this.state.title}
        description={this.state.description}
        logo={this.state.logo}
        formWarningOpen={this.state.warning}
        clearWarning={this.clearWarning}
        setField={this.setField}
        handleSubmit={this.handleSubmit}
        handlePdfInput={this.handlePdfInput}
        removePdf={this.removePdf}
        featuredProduct={this.state.productId}
        pdfs={this.state.pdfsToUpload}
        isPublic={this.props.isPublic}
        handleIsPublic={this.props.storeIsPublic}
      />
    );
  }
}

const mapStateToProps = state => ({
  wholeState: state.pdfs,
  pdfs: parseListOfPdfs(state.pdfs.get('pdfs')),
  isPublic: parseArePdfsPublic(state.pdfs.get('isPublic')),
});

const mapDispatchToProps = dispatch => ({
  clearPdfsForm: (payload) => {
    dispatch(clearPdfsForm(payload))
  },
  uploadPdfs: (payload) => {
    dispatch(uploadPdfs(payload))
  },
  storeIsPublic: (payload) => {
    dispatch(storeIsPublic(payload))
  },
  storeIsPublicForAllPdfs: (payload) => {
    dispatch(storeIsPublicForAllPdfs(payload))
  },
  editPdfs: (payload) => {
    dispatch(editPdfs(payload))
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(PdfsAddHOC);



// WEBPACK FOOTER //
// ./src/containers/PdfsAddHOC.js